import React, { useState, useEffect } from "react";

function Navbar({ theme, toggleTheme }) {
  const [scrolled, setScrolled] = useState(false);

  // Scroll listener
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (!element) return;

    const yOffset = -80; // navbar height
    const y =
      element.getBoundingClientRect().top +
      window.pageYOffset +
      yOffset;

    window.scrollTo({ top: y, behavior: "smooth" });
  };

  const bgClass = scrolled
    ? theme === "dark"
      ? "bg-gray-900 text-white shadow-md"
      : "bg-white text-gray-900 shadow-md"
    : "bg-transparent text-white";

  return (
    <nav
      className={`fixed top-0 w-full z-50 transition-colors duration-300 ${bgClass}`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          {/* Logo */}
          <div className="flex-shrink-0">
            <h1
              className="text-2xl font-bold ml-2 cursor-pointer"
              onClick={() => scrollToSection("home")}
            >
              EC Experts Inc
            </h1>
          </div>

          {/* Desktop Links */}
          <div className="hidden md:flex space-x-6 font-medium">
            {["home", "services", "about", "Testimony","contact"].map((sec) => (
              <button
                key={sec}
                onClick={() => scrollToSection(sec)}
                className="capitalize transition-colors duration-300 hover:text-red-700"
              >
                {sec}
              </button>
            ))}
          </div>

          {/* Theme Toggle */}
          <div className="ml-6 flex flex-col items-center">
            <span className="text-xs mb-1 font-medium">
              Switch Theme
            </span>

            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                className="sr-only peer"
                checked={theme === "dark"}
                onChange={toggleTheme}
              />
              <div className="w-11 h-6 bg-gray-300 rounded-full peer dark:bg-gray-700 peer-checked:bg-red-700 transition-colors duration-300"></div>
              <span className="absolute left-1 top-1 w-4 h-4 bg-white rounded-full shadow-md transform peer-checked:translate-x-5 transition-transform duration-300"></span>
            </label>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
